import { LayerRenderer } from '../LayerRenderer';
import { CloseButton, animationClass, cardStyle, useDismissible, type SurfaceProps } from './common';

/**
 * Lišta: `top_bar` / `bottom_bar` (fixní pop-up přes šířku) a `announcement`
 * (weblayer V TOKU dokumentu — netlačí obsah skokem, žádný CLS). Šířkové
 * nastavení se u lišty ignoruje.
 */
export function BarSurface({ layer, onClose, onInteract, onSubmitted }: SurfaceProps) {
  const settings = layer.doc.settings;
  useDismissible(onClose);

  const kindClass =
    layer.kind === 'top_bar'
      ? 'layer-bar is-top'
      : layer.kind === 'bottom_bar'
        ? 'layer-bar is-bottom'
        : 'layer-bar is-announcement';

  return (
    <div
      className={`${kindClass} ${animationClass(settings)}`}
      style={cardStyle(settings, false)}
      role="region"
      aria-label={settings.dismissLabel ?? 'Sdělení'}
    >
      <div className="layer-bar-inner">
        <LayerRenderer
          layer={layer}
          onClose={onClose}
          onInteract={onInteract}
          onSubmitted={onSubmitted}
        />
      </div>
      {(settings.closeButton ?? true) && <CloseButton onClose={onClose} />}
    </div>
  );
}
